import apiClient from "./axios"

const BASE_URL = "/contact-form"

export const getContactFormMessages = async (params = {}) => {
  const response = await apiClient.get(`${BASE_URL}/messages`, { params })
  return response.data
}
